import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { AddButton, DataGrid, EditButton, formatters, DeleteButton } from '../../../../Core/Controls';
import AddEditNotes from './addEditNotes';
import DeleteNotes from './deleteNotes';
import DialogComp from '../../../../Core/Dialog/DialogComp';
import '../../../commonStyle.scss';
import { NotesProvider, NotesScreenContext } from './NotesProvider';
import { useLoginInfo } from '../../../../Core/Hooks/useLoginInfo';
import GijgoGrid from '../../../../Core/Controls/GijgoGrid';
import { AppStorage } from '../../../../Core/Basic/storage-service';
import ReactDOM from 'react-dom';
import { useHistory } from 'react-router-dom';
import { GetNotesExcelFile } from '../../../../Core/Services/InternalUser/excelDownload';

const baseColumns = [
    { key: '    ', name: 'Title', width: 150 },
    { key: 'noteDescription', name: 'Description' },
    { key: 'noteStickyDisplayFromDate', name: 'Start Date', formatter: formatters.Date_DDMMMYYYY_HHMM, width: 130 },
    { key: 'noteStickyDisplayEndDate', name: 'End Date', formatter: formatters.Date_DDMMMYYYY_HHMM, width: 130 }
];

const style = {
    linkable: {
        cursor: 'pointer',
        color: 'black',
        fontWeight: 'bold'
    }
};

export const NoteDashboard = (props) => {
    const history = useHistory();

    const { state, handleAdd, closeNoteModal, title, handleDelete, deleteTitle, handleDeleteSubmit } = useContext(NotesScreenContext);
    let { isReadOnlyUser } = useLoginInfo();
    let checkhaveAccess = AppStorage.getAllowAcces();
    const dataFormatter = (data, row) => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                {
                    <>
                        <EditButton onClick={() => handleAdd(row.noteId)} toolTipTitle="Edit Note" />
                        {!isReadOnlyUser && checkhaveAccess?.CanDeleteNotes && (
                            <DeleteButton onClick={() => handleDelete(row.noteId)} toolTipTitle="Delete Note" />
                        )}
                    </>
                }
            </div>
        );
    };

    const reDirectToScreen = (row) => {
        if (props.frompage === 'Vehicles' || props.frompage === 'vehicleNoteAutoCreated') {
            history.push({
                pathname: `/controller/editVehicle/${row.recordID}`
            });
        }
        if (props.frompage === 'ServiceAgents') {
            history.push({
                pathname: `/controller/editServiceAgent/${row.recordID}`
            });
        }
        if (props.frompage === 'Jobs') {
            history.push({
                pathname: `/controller/jobTabScreen/${row?.recordID}/${row?.vehicleID}`
            });
        }
        if (props.frompage === 'Customers') {
            history.push({
                pathname: `/controller/editcustomer/${row?.recordID}/${row.noteType}`
            });
        }
        if (props.frompage === 'Depots') {
            history.push({
                pathname: `/controller/Depots/${row.recordID}`
            });
        }
    };

    const NoteTypeFormatter = useCallback(
        ({ row, col }, grid) => {
            const spn = document.createElement('span');
            const canAccess =
                (props.frompage === 'Vehicles' && checkhaveAccess?.CanViewVehicles) ||
                (props.frompage === 'vehicleNoteAutoCreated' && checkhaveAccess?.CanViewVehicles) ||
                (props.frompage === 'Customers' && checkhaveAccess?.CanViewCustomers) ||
                (props.frompage === 'Jobs' && checkhaveAccess?.CanViewJobs) ||
                (props.frompage === 'ServiceAgents' && checkhaveAccess?.CanViewServiceAgents) ||
                (props.frompage === 'Depots' && checkhaveAccess?.CanViewDepots);

            const lnk = (
                <div style={canAccess ? style.linkable : {}} onClick={canAccess ? () => reDirectToScreen(row) : undefined}>
                    {row.noteType}
                </div>
            );

            ReactDOM.render(lnk, spn);
            return spn;
        },
        [props.frompage, checkhaveAccess]
    );

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];

        if (checkhaveAccess?.CanViewNotes && state.userBasePermi) {
            tempCols.splice(0, 0, {
                key: 'action',
                name: 'Action',
                width: '80',
                formatter: dataFormatter
            });
        }

        if (props.showNoteType) {
            tempCols.splice(1, 0, {
                key: 'noteType',
                name:
                    props.frompage === 'Customers'
                        ? 'Customers Name'
                        : props.frompage === 'Drivers'
                          ? 'Drivers Name'
                          : props.frompage === 'Depots'
                            ? 'Depots Name'
                            : props.frompage === 'ServiceAgents'
                              ? 'Service Area Name'
                              : props.frompage === 'Vehicles' || props.frompage === 'vehicleNoteAutoCreated'
                                ? 'Reg No'
                                : props.frompage === 'Jobs'
                                  ? 'Jobs Ref'
                                  : 'Note Type',
                width: props.frompage === 'Customers' || props.frompage === 'Depots' ? 280 : 150,
                formatter: NoteTypeFormatter
            });
        }

        return tempCols;
    }, [state.userBasePermi, checkhaveAccess, props.frompage, props.showNoteType]);

    const gridBtnTitle = `Add ${props.frompage === 'ServiceAgents' ? 'Service Area' : props.frompage} Notes`;
    return (
        <div>
            <GijgoGrid
                columns={columns}
                getUrl={state.response}
                dataConverter={(res) => ({
                    records: res.data.notelist,
                    total: res.data.total
                })}
                isReload={state.isReload}
                btnTitle={state.userBasePermi && !props.hideAddBtn ? gridBtnTitle : ''}
                onBtnClick={() => handleAdd(null)}
                downloadBtnName={` ${props.frompage} Notes Excel`}
                downloadCustomUrl={(params) =>
                    GetNotesExcelFile({
                        fileExt: 'xlsx',
                        url: state.response,
                        frompage: props.frompage
                    })
                }
            />
            {state.show ? (
                <DialogComp title={title} onClose={() => closeNoteModal(false)} maxWidth="sm">
                    <AddEditNotes NoteID={state.noteID} onFormSubmit={() => closeNoteModal(true)} {...props} />
                </DialogComp>
            ) : null}
            {state.showDelete ? (
                <DialogComp title={deleteTitle} onClose={() => closeNoteModal(false)} maxWidth="sm">
                    <DeleteNotes NoteID={state.noteID} onFormCancel={() => closeNoteModal(true)} onFormSubmit={() => handleDeleteSubmit()} {...props} />
                </DialogComp>
            ) : null}
        </div>
    );
};

const Screen = (props) => {
    return (
        <NotesProvider {...props}>
            <NoteDashboard {...props} />
        </NotesProvider>
    );
};
export default Screen;
